export default __webpack_public_path__ + "5159fbda8d4c9b3de2fa647ab7d3ad9f.jpg";